import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-register-before-leave-dialog',
  templateUrl: './register-before-leave-dialog.component.html',
  styleUrl: './register-before-leave-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton],
})
export class RegisterBeforeLeaveDialogComponent {
  dialogRef = inject<MatDialogRef<RegisterBeforeLeaveDialogComponent>>(MatDialogRef);

  close() {
    this.dialogRef.close();
  }
}
